// providers/defaults.ts
import * as Api from '@ViewModels';
import { provider } from './helpers';

/**
 * Default configuration for providers without specific config.
 * Provides sensible defaults that work for most integrations.
 */
export const defaultProviderConfig = provider(Api.IntegrationProvider.None, {
	displayName: 'Unknown Provider',

	main: {
		writebacks: true,
	},

	keyFacts: {
		birthdayDisplay: true,
	},

	tags: {
		coreTags: true,
	},
});
